module.exports = __webpack_public_path__ + "img/20200302131516360截图20200302130459568.8dfdbfbe.jpg";